import { render } from "./LobbiesView.vue?vue&type=template&id=6f972488&scoped=true"
import script from "./LobbiesView.vue?vue&type=script&lang=js"
export * from "./LobbiesView.vue?vue&type=script&lang=js"

import "./LobbiesView.vue?vue&type=style&index=0&id=6f972488&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f972488"]])

export default __exports__